import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FULL_WEEKDAY_LABELS, WEEKDAY_LABELS } from "@/utils/dayUtill";

interface NurseMyWeeklyOffSectionProps {
  weeklyOffWeekday: number | null;
  initialWeeklyOffWeekday: number | null;
  onWeeklyOffChange: (value: number | null) => void;
  cycleStartDate?: string | undefined;
  disabled?: boolean;
}

export default function NurseMyWeeklyOffSection({
  weeklyOffWeekday,
  initialWeeklyOffWeekday,
  onWeeklyOffChange,
  cycleStartDate,
  disabled,
}: NurseMyWeeklyOffSectionProps) {
  return (
    <div>
      <label className="block text-[15px] font-semibold text-[#939393] mb-[7px] font-pretendard">
        주휴
      </label>

      <Select
        value={weeklyOffWeekday !== null ? String(weeklyOffWeekday) : "none"}
        onValueChange={(value) =>
          onWeeklyOffChange(value === "none" ? null : Number(value))
        }
        disabled={disabled ?? false}
      >
        <SelectTrigger className="w-full h-[35px] border-[#D6D6DE] rounded-[5px] text-[15px] font-pretendard">
          <SelectValue placeholder="선택" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">-</SelectItem>
          {WEEKDAY_LABELS.map((day, index) => (
            <SelectItem key={index} value={String(index)}>
              {day}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
